// extracted by mini-css-extract-plugin
export default {"subtitle":"UserListPopup_subtitle__IL7z8"};